<template>
  <div class="listBox">
    <div class="listItems" v-for="(item,index) in data" :key="index"  @click="CommodityDetails(item.goods_id)">
      <van-row>
        <van-col span="8">
          <div class="masterImg">
            <img :src="item.original ? item.original : $store.state.defaultImg" />
          </div>
        </van-col>
        <van-col span="16">
          <p class="ItemTitle van-multi-ellipsis--l2">{{item.goods_name}}</p>
          <!-- <p class="ItemTitle twoLine">{{item.goods_name}}</p> -->
          <div class="Commission"  >
            <span v-if="item.rake_back_amount != null">
               拥金¥{{item.rake_back_amount}}
            </span>
            </div>
          <div class="ItemPrice">
            <span class="Price">{{item.price}}</span>
             <i class="Deduction"  v-if="item.point == null" >重消0</i>
            <i class="Deduction"  v-else>重消{{item.point}}</i>
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- <div class="listItems">
      <van-row>
        <van-col span="8">
          <div class="masterImg">
            <img src="../assets/img/tmp/goodsList/goods2.png" />
          </div>
        </van-col>
        <van-col span="16">
          <p class="ItemTitle van-multi-ellipsis--l2">智声破壁机加热破壁经典款现代播放器蓝牙免</p>
          <div class="Commission">拥金¥1.5</div>
          <div class="ItemPrice">
            <span class="Price">109.9</span>
            <i class="Deduction">重消30</i>
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="listItems">
      <van-row>
        <van-col span="8">
          <div class="masterImg">
            <img src="../assets/img/tmp/goodsList/goods1.png" />
          </div>
        </van-col>
        <van-col span="16">
          <p class="ItemTitle van-multi-ellipsis--l2">现代车载MP3播放器蓝牙免提电话汽车点烟免提电话汽车点烟</p>
          <div class="Commission">拥金¥1.5</div>
          <div class="ItemPrice">
            <span class="Price">109.9</span>
            <i class="Deduction">重消30</i>
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="listItems">
      <van-row>
        <van-col span="8">
          <div class="masterImg">
            <img src="../assets/img/tmp/goodsList/goods2.png" />
          </div>
        </van-col>
        <van-col span="16">
          <p class="ItemTitle van-multi-ellipsis--l2">智声破壁机加热破壁经典款现代播放器蓝牙免</p>
          <div class="Commission">拥金¥1.5</div>
          <div class="ItemPrice">
            <span class="Price">109.9</span>
            <i class="Deduction">重消30</i>
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="listItems">
      <van-row>
        <van-col span="8">
          <div class="masterImg">
            <img src="../assets/img/tmp/goodsList/goods1.png" />
          </div>
        </van-col>
        <van-col span="16">
          <p class="ItemTitle van-multi-ellipsis--l2">现代车载MP3播放器蓝牙免提电话汽车点烟免提电话汽车点烟</p>
          <div class="Commission">拥金¥1.5</div>
          <div class="ItemPrice">
            <span class="Price">109.9</span>
            <i class="Deduction">重消30</i>
          </div>
        </van-col>
      </van-row>
    </div>-->
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: [],
      required: false
    }
  },
  methods: {
    CommodityDetails(goodsId) {
      this.$router.push({path:'./goodsDetail',query:{	goods_id : goodsId}}) 

      // this.$parent.goCommodityDetails(goodsId);
      //  this.$emit("goCommodityDetails",goodsId)
    }
  }
};
</script>
<style scoped lang='less'>
.listBox {
  width: 100%;
  .listItems {
    padding: 20px 24px 20px 24px;
    background-color: #fff;
    margin-bottom: 20px;
    .masterImg {
      img {
        width: 204px;
        height: 204px;
      }
    }
    .ItemTitle {
      font-size: 26px;
      color: #262626;
      text-align: left;
      height: 74px;
    }
    .Commission {
      font-size: 24px;
      color: #fe5508;
      margin: 12px 0;
      text-align: left;
      height: 34px;
       span{
          padding: 4px 10px;
          background-color: #FFF1EB;
       }
    }
    .ItemPrice {
      text-align: left;
      .Price {
        display: inline-block;
        font-size: 30px;
        color: #ff1919;
        font-weight: 600;
        position: relative;
        left: 15px;
        &:after {
          content: "¥";
          position: absolute;
          left: -15px;
          bottom: 0;
          font-size: 22px;
          color: #ff1919;
          font-weight: 600;
        }
      }
      .Deduction {
        font-style: normal;
        display: block;
        font-size: 24px;
        color: #999999;
        text-align: left;
      }
    }
  }
}
</style>